export enum IconBlockMode {
  Mode1 = 'mode1',
  Mode2 = 'mode2'
}
